<template>
<ItpDataTable
  tableId="RentalFormServices"
  :editable="editable"
  :isRowEditable="p => !p.locked"
  :value="_.orderBy(items, ['created_at', 'valid_from', 'valid_to'], ['desc', 'desc', 'desc'])"
  :rowTemplate="schemaDefaults('CreateRentalService', {
    rental_id: rentalId,
    valid_from: $fn.today(),
  })"
  :columns="b_7315092382398562_columns"
  class="h-100"
  ref="tableServices"
  v-if="loaded"
  @save="evh_7315092382398562_save($event, {})"
  @delete="evh_7315092382398562_delete($event, {})"
  @meter:selected="evh_7315092382398562_meterSelected($event, {})"
>
</ItpDataTable>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRentalFormServicesTable extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onMeterSelected(...args: any[]) {
    const { col, option, row, value } = args[0].data;

    if (value && value.unit) {
      row.billing_unit = value.unit;
    }
  }

  @Prop({
    type: Boolean,
    default: true,
  })
  editable!: boolean;

  @Watch('editable')
  onEditable(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("editable")
  }

  @Prop({
    required: true,
    type: String,
  })
  rentalId!: string;

  @Watch('rentalId')
  onRental_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rentalId")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_rental_service', { parameters: { rental_id: this.rentalId } })
      .then(d => _.orderBy(d, ['id']))
  }

  units!: any;

  async $$load_units() {
    return this.$fn.fetch('list_unit').then(d => _.orderBy(d, [p => p.symbol.toLowerCase()]))
  }

  ux!: any;
  b_7315092382398562_columns!: any;

  async $$load_b_7315092382398562_columns() {
    return [{
      name: "locked",
      type: "lock",
    }
      ,
    {
      name: "inactive",
      header: this.$fn.gettext("Inactive"),
      width: "30px",
      textAlign: "center",
      formatter: {
        name: "checkbox",
      }
      ,
      editor: {
        name: "checkbox",
      }
      ,
    }
      ,
    {
      name: "valid_from",
      type: "date",
      header: this.$fn.gettext("Valid From"),
      width: "120px",
    }
      ,
    {
      name: "valid_to",
      type: "date",
      header: this.$fn.gettext("Valid To"),
      width: "120px",
    }
      ,
    {
      name: "service",
      type: "select2",
      header: this.$fn.gettext("Service"),
      width: "250px",
      required: true,
      path: "name",
      bindObject: true,
      textField: "name",
      options: this.$fn.searchDataSource('suggest_product', { product_types: ['service'] }),
    }
      ,
    {
      name: "meter",
      type: "select2",
      header: this.$fn.gettext("Meter"),
      width: "250px",
      path: "serial_number",
      bindObject: true,
      textField: "serial_number",
      options: this.$fn.searchDataSource('suggest_meter', { t: 'rentalService' }),
      formatter: {
        name: "template",
        value: "<b-link :to=\"{\n\
  name: 'app.meter',\n\
  params: { id: row.meter.id }\n\
}\">{{ row.meter.serial_number }}</b-link>\n\
",
      }
      ,
    }
      ,
    {
      name: "billing_unit",
      type: "select2",
      header: this.$fn.gettext("Billing Unit"),
      width: "120px",
      path: "billing_unit",
      valueField: "symbol",
      textField: "symbol",
      required: true,
      options: this.units,
    }
      ,
    {
      name: "meter_factor",
      type: "number",
      header: this.$fn.gettext("Factor"),
      width: "100px",
    }
      ,
    {
      name: "notes",
      header: this.$fn.gettext("Notes"),
      width: "320px",
    }
      ,
    ]
  }

  dataMembers = ['items', 'units', 'ux', 'b_7315092382398562_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        units: null,
        ux: {
          initialLoadSpinner: true,
        }
        ,
        b_7315092382398562_columns: null,
      },
    }
  }

  async act_7315092382398562_script_9544_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_9544, alias=undefined
    $event.data.waitFor(
      this.$fn.crud('rental_service').upsert({
        ...$event.data.row,
        asset_id: $event.data.row.asset_id,
        service_id: $event.data.row.service.id,
        meter_id: _.get($event.data.row, 'meter.id'),
      })
    )
  }

  async act_7315092382398562_script_9544_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_9544, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_9544_getActionArgs_value($event),
    }
  }

  async evh_7315092382398562_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_save.executeFromDOM(this, event, scope);
  }

  async act_7315092382398562_script_9546_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_9546, alias=undefined
    $event.data.waitFor(this.$fn.crud('rental_service').delete($event.data.row))
  }

  async act_7315092382398562_script_9546_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_9546, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_9546_getActionArgs_value($event),
    }
  }

  async evh_7315092382398562_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_delete.executeFromDOM(this, event, scope);
  }

  async act_7315092382398562_script_9548_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_9548, alias=undefined
    this.onMeterSelected($event)
  }

  async act_7315092382398562_script_9548_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_9548, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_9548_getActionArgs_value($event),
    }
  }

  async evh_7315092382398562_meterSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_meterSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_script_9544: actions.ScriptAction;
    evh_7315092382398562_save_9543: actions.EventHandlerImpl;
    evh_7315092382398562_save: actions.EventHandlerGroup;
    act_7315092382398562_script_9546: actions.ScriptAction;
    evh_7315092382398562_delete_9545: actions.EventHandlerImpl;
    evh_7315092382398562_delete: actions.EventHandlerGroup;
    act_7315092382398562_script_9548: actions.ScriptAction;
    evh_7315092382398562_meterSelected_9547: actions.EventHandlerImpl;
    evh_7315092382398562_meterSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_script_9544 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_9544_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_save_9543 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_9544,
        event: "save",
        displayName: "script",
      }
    );
    const evh_7315092382398562_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_save_9543],
      }
    );
    const act_7315092382398562_script_9546 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_9546_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_delete_9545 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_9546,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_7315092382398562_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_delete_9545],
      }
    );
    const act_7315092382398562_script_9548 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_9548_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_meterSelected_9547 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_9548,
        event: "meter:selected",
        displayName: "script",
      }
    );
    const evh_7315092382398562_meterSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_meterSelected_9547],
      }
    );
    return {
      act_7315092382398562_script_9544,
      evh_7315092382398562_save_9543,
      evh_7315092382398562_save,
      act_7315092382398562_script_9546,
      evh_7315092382398562_delete_9545,
      evh_7315092382398562_delete,
      act_7315092382398562_script_9548,
      evh_7315092382398562_meterSelected_9547,
      evh_7315092382398562_meterSelected,
    }
  }
}

Vue.component("UcRentalFormServicesTable", UcRentalFormServicesTable);

</script>